import styled from 'styled-components';
import { Text, ToggleButton, ToggleButtonGroup } from '@solvhealth/jigsaw-v1';
import React from 'react';
import { AddressOption } from './SuggestedAddressModal';

const ToggleButtonContent = styled.div.withConfig({ componentId: 'sc-1be26fm-0' })`
  padding: 0px;
  @media (min-width: 768px) {
    padding: 8px;
  }
  width: 100%;
`;

const AddressLineContainer = styled.div.withConfig({ componentId: 'sc-1be26fm-1' })`
  display: flex;
  align-items: center;
`;

const AddressLinesContainer = styled.div.withConfig({ componentId: 'sc-1be26fm-2' })`
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-top: 8px;
`;

const AddressPart = ({
  token,
  isUserInput,
  isChanged,
  isLast,
}: {
  token: string;
  isUserInput?: boolean;
  isChanged: boolean;
  isLast: boolean;
}) => {
  const backgroundColor = isUserInput ? 'cherry-light' : 'mint-light';
  const textColor = isUserInput ? 'cherry-dark' : 'mint-dark';
  return (
    <Text
      {...(isChanged ? { backgroundColor } : {})}
      {...(isChanged ? { textColor } : {})}
      key={token}
      style={{
        padding: isChanged ? '4px' : '0px',
        marginRight: isLast ? '0px' : '4px',
        borderRadius: isChanged ? '4px' : '0px',
      }}
    >
      {token}
    </Text>
  );
};

export function AddressValidationCards({
  diffs,
  selectedAddressOption,
  handleChange,
}: {
  diffs: any;
  selectedAddressOption: AddressOption;
  handleChange: (addressOption: AddressOption) => void;
}) {
  return (
    <ToggleButtonGroup
      column
      onChange={(value) => handleChange(value as AddressOption)}
      value={selectedAddressOption}
    >
      <ToggleButton value="validatedAddress" width="100%">
        <ToggleButtonContent>
          <Text variant="h4">Suggested address</Text>
          <AddressLinesContainer>
            <AddressLineContainer>
              <AddressPart
                isChanged={diffs.address1.diff}
                isLast={false}
                token={diffs.address1.suggested}
              />
              {!!diffs.address2.suggested && (
                <AddressPart
                  isChanged={diffs.address2.diff}
                  isLast={false}
                  token={diffs.address2.suggested}
                />
              )}
            </AddressLineContainer>
            <AddressLineContainer>
              <AddressPart
                isChanged={diffs.city.diff}
                isLast={false}
                token={diffs.city.suggested}
              />
              <AddressPart
                isChanged={diffs.state.diff}
                isLast={false}
                token={diffs.state.suggested}
              />
              <AddressPart isChanged={diffs.zip.diff} isLast={false} token={diffs.zip.suggested} />
            </AddressLineContainer>
          </AddressLinesContainer>
        </ToggleButtonContent>
      </ToggleButton>{' '}
      <ToggleButton value="submittingAddress" width="100%">
        <ToggleButtonContent>
          <Text variant="h4">Original address</Text>
          <AddressLinesContainer>
            <AddressLineContainer>
              <AddressPart
                isChanged={diffs.address1.diff}
                isLast={false}
                isUserInput
                token={diffs.address1.supplied}
              />
              {!!diffs.address2.supplied && (
                <AddressPart
                  isChanged={diffs.address2.diff}
                  isLast={false}
                  isUserInput
                  token={diffs.address2.supplied}
                />
              )}
            </AddressLineContainer>
            <AddressLineContainer>
              <AddressPart
                isChanged={diffs.city.diff}
                isLast={false}
                isUserInput
                token={diffs.city.supplied}
              />
              <AddressPart
                isChanged={diffs.state.diff}
                isLast={false}
                isUserInput
                token={diffs.state.supplied}
              />
              <AddressPart
                isChanged={diffs.zip.diff}
                isLast={false}
                isUserInput
                token={diffs.zip.supplied}
              />
            </AddressLineContainer>
          </AddressLinesContainer>
        </ToggleButtonContent>
      </ToggleButton>
    </ToggleButtonGroup>
  );
}
